import { axiosInstance as axios } from '../lib/axios'
import { IPIRANGA_PROMOTION_AVAILABLE } from '../actionTypes/ipirangaPromotion'
import { isIpirangaPromotionMockEnabled } from '../views/IpirangaPromotionListPage/hooks/ipirangaPromotionMock'

// REV-1872: POST /national-promotion/available responde se ALGUM dos postos
// participa de promoção Ipiranga ativa ({ success: boolean }). Controla a
// exibição do item "Promoção Ipiranga" nos menus. Falha de rede = oculto.
export const getIpirangaPromotionAvailable = (storeIds) => async (dispatch) => {
  const dispatchAvailable = (available) =>
    dispatch({ type: IPIRANGA_PROMOTION_AVAILABLE, payload: available })

  if (isIpirangaPromotionMockEnabled()) {
    dispatchAvailable(true)
    return
  }

  if (!Array.isArray(storeIds) || storeIds.length === 0) {
    dispatchAvailable(false)
    return
  }

  try {
    const { data } = await axios.post('/national-promotion/available', { store_ids: storeIds })
    dispatchAvailable(data?.success === true)
  } catch (error) {
    dispatchAvailable(false)
  }
}
